var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors;
  return {
    boldFontWeight: typography.fontWeightBold,
    normalFontWeight: typography.fontWeightNormal,
    emptyTextMargin: spacing.small,
    pageBackgroundColor: colors.contrasts.white1010,
    sectionWrapperMargin: spacing.xSmall,
    sectionWrapperPadding: spacing.xSmall,
    sectionWrapperPaddingRight: spacing.medium
  };
};
export default generateComponentTheme;